/**
 * /frontend/src/features/analytics/components/peak/DayComparisonChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';
import { toDayComparisonSeries } from '../../utils/chartDataTransformers';

/**
 * Day-over-day comparison chart.
 * @param {{comparison:any}} props
 * @returns {JSX.Element}
 */
const DayComparisonChart = ({ comparison }) => {
  const data = useMemo(() => toDayComparisonSeries(comparison), [comparison]);
  const lines = useMemo(() => ([
    { key: 'today', label: 'Today', color: CHART_COLORS.accent },
    { key: 'lastWeek', label: 'Last week', color: CHART_COLORS.accentStrong },
    { key: 'rollingAvg', label: '4-week avg', color: CHART_COLORS.accentCyan }
  ]), []);

  return (
    <ChartContainer title="Day Comparison" subtitle="Today vs same day last week vs 4-week average">
      <TrendLineChart data={data} xKey="hourLabel" lines={lines} />
    </ChartContainer>
  );
};

export default DayComparisonChart;

